import { OPEN_WINDOW } from '../actionTypes/LoginModalWindow';

export const loginModalWindow = () => ({
    type: OPEN_WINDOW,
});


// export function setLoginModalWindowOpen() {
//     return dispatch => {
//         dispatch(loginModalWindow(OPEN_WINDOW));
//     };
// }
